import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { ArrowBackIcon, HeaderCloseIcon, RefreshIcon } from 'shared/ui/icon';

import './header.css';

// 추후에 객체로 변경 하던, 전역 상태로 관리하던 후처리 필요해 보임
const USED_BACK_PAGE_LIST = ['/hsptlz/form/caregiver-form/*', '/hsptlz/form/mobile-form/*'];

export const Header = ({ title }) => {
  const [useBack, setUseBack] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const isBackPage = USED_BACK_PAGE_LIST.some((pattern) =>
      pattern.endsWith('/*') ? location.pathname.startsWith(pattern.replace('/*', '')) : location.pathname === pattern,
    );
    setUseBack(isBackPage);
  }, [location.pathname]);

  return (
    <>
      <div className='header'>
        {useBack && (
          <button className='btn-back' aria-label='뒤로가기' onClick={() => navigate(-1)}>
            <ArrowBackIcon />
          </button>
        )}

        <h1 className='header-title'>{title}</h1>
        <div className='header-right-menu'>
          {/* <button className='btn-refresh' aria-label='새로 고침'>
            <RefreshIcon />
          </button> */}
          {/* <button className='btn-close' aria-label='닫기'>
            <HeaderCloseIcon />
          </button> */}
        </div>
      </div>
    </>
  );
};
